import React from "react";
import { useTranslation } from "react-i18next";
import {
  getPlatformRoleAccessLevel,
  PLATFORM_ROLE_PERMISSION_RESOURCES,
} from "@/components/pages/users/utils/platformRolePermissions";

interface PlatformRolePermissionCellsProps {
  permissionKeys: readonly string[];
}

export const PlatformRolePermissionCells: React.FC<
  PlatformRolePermissionCellsProps
> = ({ permissionKeys }) => {
  const { t } = useTranslation();

  return (
    <>
      {PLATFORM_ROLE_PERMISSION_RESOURCES.map((resource) => {
        const accessLevel = getPlatformRoleAccessLevel(
          permissionKeys,
          resource,
        );

        return (
          <div key={resource} className="text-xs">
            {t(`users.roles.accessLevels.${accessLevel}`)}
          </div>
        );
      })}
    </>
  );
};
